<script setup lang="ts">
import WMTSTileGrid from 'ol/tilegrid/WMTS'
import TileImage from 'ol/source/TileImage'
import ImageTile from 'ol/ImageTile'
import { useGeoDataStore } from '~/stores/geoData'

const geoDataStore = useGeoDataStore()
const token = computed(() => geoDataStore.lantmaterietAuth)

onBeforeMount(async () => {
  await geoDataStore.getToken()
})

const source = ref<{ source: TileImage } | null>(null)
watch(source, (sourceWrapper) => {
  if (!sourceWrapper) return
  sourceWrapper.source.setTileLoadFunction((tile: any, src) => {
    const xhr = new XMLHttpRequest()
    xhr.responseType = 'blob'
    xhr.open('GET', src)
    xhr.setRequestHeader('Authorization', 'Basic ' + token.value)
    xhr.onload = function () {
      if (this.response) {
        const objectUrl = URL.createObjectURL(xhr.response)
        tile.getImage().onload = function () {
          URL.revokeObjectURL(objectUrl)
        }
        tile.getImage().src = objectUrl
      } else {
        tile.setState(3)
      }
    }
    xhr.onerror = function () {
      tile.setState(3)
    }
    xhr.send()
  })
})

const resolutions = [
  156543.033928041, 78271.51696402048, 39135.75848201023, 19567.87924100512, 9783.939620502561,
  4891.96981025128, 2445.98490512564, 1222.99245256282, 611.49622628141, 305.7481131407048,
  152.8740565703525, 76.43702828517624, 38.21851414258813, 19.10925707129406, 9.554628535647032,
  4.777314267823516, 2.388657133911758, 1.194328566955879,
]

const tilematrix: '3006' | '3857' = '3857'
const matrixIds = [
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
]

const url = ref(
  `https://maps.lantmateriet.se/topowebb/v1.1/wmts/1.0.0/topowebb_nedtonad/default/${tilematrix}/{z}/{y}/{x}.png`
)
const attribution = ref(
  '<a href="https://www.lantmateriet.se/">Lantmäteriet</a> | <a href="https://creativecommons.org/licenses/by/4.0/">CC BY 4.0</a>'
)

const tileGrid = new WMTSTileGrid({
  matrixIds,
  resolutions,
  origin: [-20037508.342789, 20037508.342789],
})
</script>

<template>
  <ol-tile-layer v-if="token" :z-index="1">
    <ol-source-xyz ref="source" :url="url" :tile-grid="tileGrid" :attributions="attribution" />
  </ol-tile-layer>
</template>
<style lang="scss" scoped></style>
